import { HTMLAttributes, ReactNode } from "react";
import cn from "clsx";

// v8-Chip — konsumiert NUR Tokens (Radius --radius-chip, Border/Text/Flaechen).
// Drei Varianten:
//   hebel   : neutrales Outline (kein Farbcode je Hebel — Farbdisziplin).
//   status  : gefuellter Soft-Ton (semantisch via `tone`).
//   effort  : quadratisches S/M/L-Badge (tabellarische Zahl).
export type ChipVariant = "hebel" | "status" | "effort";
export type ChipTone = "neutral" | "petrol" | "success" | "danger";

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
  /** Nur fuer variant="status": der semantische Soft-Ton. */
  tone?: ChipTone;
  children: ReactNode;
}

const STATUS_TONE: Record<ChipTone, string> = {
  neutral: "bg-surface-3 text-text-2",
  petrol: "bg-accent-50 text-accent-700 border border-accent-100",
  success: "bg-success-soft text-success",
  danger: "bg-danger-soft text-danger",
};

export function Chip({ variant = "hebel", tone = "neutral", className, children, ...rest }: ChipProps) {
  if (variant === "effort") {
    return (
      <span
        className={cn(
          "inline-grid place-items-center w-5 h-5 rounded-chip border border-border-strong",
          "text-[0.7rem] font-semibold tabular-nums text-text-2",
          className,
        )}
        {...rest}
      >
        {children}
      </span>
    );
  }
  if (variant === "status") {
    return (
      <span
        className={cn(
          "inline-flex items-center whitespace-nowrap rounded-chip px-2 py-[3px] text-[0.72rem] font-medium",
          STATUS_TONE[tone],
          className,
        )}
        {...rest}
      >
        {children}
      </span>
    );
  }
  // hebel (default) — neutrales Outline
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-chip border border-border-strong bg-surface",
        "px-2 py-[3px] text-[0.72rem] font-medium text-text-2",
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}

export default Chip;
